import {stopFilledSvg as Icon__small__stopFilledSvg} from '../Icon__small/Icon__small--stopFilled.js';
import {stopFilledSvg as Icon__xsmall__stopFilledSvg} from '../Icon__xsmall/Icon__xsmall--stopFilled.js';
import {stopFilledSvg as Icon__xxsmall__stopFilledSvg} from '../Icon__xxsmall/Icon__xxsmall--stopFilled.js';

export var stopFilled = {
  name: 'stopFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__stopFilledSvg,
  alt: {
    Icon__small: Icon__small__stopFilledSvg,
    Icon__xsmall: Icon__xsmall__stopFilledSvg,
    Icon__xxsmall: Icon__xxsmall__stopFilledSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
